import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "pagination",
  "aria-label": "Pagination"
}
const _hoisted_2 = {
  key: 0,
  "data-testid": "prev-button"
}
const _hoisted_3 = { "aria-hidden": "true" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "button-round"
}
const _hoisted_6 = {
  key: 2,
  class: "ellipsis"
}
const _hoisted_7 = {
  key: 1,
  "data-testid": "next-button"
}
const _hoisted_8 = { "aria-hidden": "true" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_ctx.currentPage > 1)
        ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
            _createElementVNode("button", {
              "aria-label": "Previous",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectPage(_ctx.currentPage - 1)))
            }, [
              _createVNode(_component_Icon, {
                name: "angle-left",
                title: "Next",
                class: "pull-left"
              }),
              _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_3, [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" Previous ", -1)
              ]))])), [
                [_directive_translate]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginationRange, (pageNumber) => {
        return (_openBlock(), _createElementBlock("li", {
          key: pageNumber,
          class: _normalizeClass({ active: pageNumber === _ctx.currentPage, 'ellipsis': !pageNumber })
        }, [
          (pageNumber && pageNumber !== _ctx.currentPage)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "button-round",
                onClick: ($event: any) => (_ctx.selectPage(pageNumber))
              }, _toDisplayString(pageNumber), 9, _hoisted_4))
            : pageNumber
              ? (_openBlock(), _createElementBlock("button", _hoisted_5, _toDisplayString(pageNumber), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, " … "))
        ], 2))
      }), 128)),
      (_ctx.currentPage < _ctx.pagesCount)
        ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
            _createElementVNode("button", {
              "aria-label": "Next",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectPage(_ctx.currentPage + 1)))
            }, [
              _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_8, [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" Next ", -1)
              ]))])), [
                [_directive_translate]
              ]),
              _createVNode(_component_Icon, {
                name: "angle-right",
                title: "Next",
                class: "pull-right"
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}